import { render } from "./AfgerondTeams.vue?vue&type=template&id=0080defb&scoped=true"
import script from "./AfgerondTeams.vue?vue&type=script&lang=js"
export * from "./AfgerondTeams.vue?vue&type=script&lang=js"

import "./AfgerondTeams.vue?vue&type=style&index=0&id=0080defb&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0080defb"]])

export default __exports__